/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ApplicationSummariesControllerCreateMutationRequest, ApplicationSummariesControllerCreateMutationResponse, ApplicationSummariesControllerCreate400, ApplicationSummariesControllerCreate401, ApplicationSummariesControllerCreate403 } from "../../models/checklistsController/ApplicationSummariesControllerCreate";

function getApplicationSummariesControllerCreateUrl() {
  const res = { method: 'POST', url: `/api/v1/checklist-application-summaries` as const }  
  return res
}

/**
 * @summary Create a new checklist application summary
 * {@link /api/v1/checklist-application-summaries}
 */
export async function applicationSummariesControllerCreate(data?: ApplicationSummariesControllerCreateMutationRequest, config: Partial<RequestConfig<ApplicationSummariesControllerCreateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<ApplicationSummariesControllerCreateMutationResponse, ResponseErrorConfig<ApplicationSummariesControllerCreate400 | ApplicationSummariesControllerCreate401 | ApplicationSummariesControllerCreate403>, ApplicationSummariesControllerCreateMutationRequest>({ method : "POST", url : getApplicationSummariesControllerCreateUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}